// src/routes.js
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Navbar from './components/VerticalNavbar';
import Home from './components/Home';
import About from './components/About';
import SmartSearch from './components/SmartSearch/SmartSearch';
import NewCMAPage from './components/NewCMAPage';
import SmartCMAPage from './components/SmartCMAPage';
import SmartMarketing from './components/SmartMarketing';
import CreationSelection from './components/CreationSelection';
import PreConEmail from './components/PreConEmail';
import PreConPreview from './components/PreConPreview';
import ReportPreview from './components/ReportPreview';
import ListingAd from './components/ListingAd';
import DesignPage from './components/DesignPage';
import ClientResources from './components/ClientResources';
import ContactsPage from './components/ContactsPage';
import Login from './components/Login/Login';
import Signup from "./components/Login/Signup";
import NewSmartReport from './components/NewSmartReport';
import SmartReportPage from './components/SmartReportPage';

// Context Providers
import { ContactsProvider } from "./components/ContactsContext";
import { CMAProvider } from "./components/CMAContext";
import { ReportProvider } from "./components/ReportContext";
import { MarketingProvider } from "./components/MarketingContext";

// **IMPORTANT**: import your Auth stuff
import { AccountProvider } from './AccountContext';
import ProtectedRoute from './ProtectedRoute';

import './assets/styles/App.css';

const routes = (
  <AccountProvider>
    <div className="core-div">
      <Navbar />
      <div className="main-content">
        <ContactsProvider>
          <MarketingProvider>
            <CMAProvider>
              <ReportProvider>
                <Switch>
                  {/* Public Route: Login */}
                  <Route path="/login" component={Login} />
                  <Route path="/signup" component={Signup} />

                  {/* Protected Routes */}
                  <ProtectedRoute path="/smart-search" component={SmartSearch} />
                  <ProtectedRoute path="/smart-cma/new-cma" component={NewCMAPage} />
                  <ProtectedRoute path="/smart-cma" component={SmartCMAPage} />
                  <ProtectedRoute exact path='/' component={Home} />
                  <ProtectedRoute path='/about' component={About} />
                  <ProtectedRoute path='/smart-marketing/:category/precon/preview' component={PreConPreview} />
                  <ProtectedRoute path='/smart-marketing/:category/precon' component={PreConEmail} />
                  <ProtectedRoute path='/smart-marketing/:category' component={CreationSelection} />
                  <ProtectedRoute path='/smart-marketing' component={SmartMarketing} />
                  <ProtectedRoute path='/designs/:category' component={DesignPage} />
                  <ProtectedRoute path='/smart-reports/new-smart-report/preview' component={ReportPreview} />
                  <ProtectedRoute path='/listingad' component={ListingAd} />
                  <ProtectedRoute path='/smart-reports/new-smart-report' component={NewSmartReport} />
                  <ProtectedRoute path='/smart-reports' component={SmartReportPage} />
                  <ProtectedRoute path='/contacts/:id' component={ClientResources} />
                  <ProtectedRoute path='/contacts' component={ContactsPage} />
                </Switch>
              </ReportProvider>
            </CMAProvider>
          </MarketingProvider>
        </ContactsProvider>
      </div>
    </div>
  </AccountProvider>
);

export { routes };
